var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true },
        },
      ],
      staticClass: "app-container",
      attrs: { "element-loading-text": "加载中..." },
    },
    [
      _c(
        "el-card",
        {
          staticClass: "sticky-container",
          attrs: { shadow: "never", "body-style": { padding: 0 } },
        },
        [
          _c(
            "template",
            { slot: "header" },
            [
              _c(
                "el-tabs",
                {
                  on: { "tab-click": _vm.handleFilter },
                  model: {
                    value: _vm.queryParams.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "status", $$v)
                    },
                    expression: "queryParams.status",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: { label: "所有店员", name: "-1" },
                  }),
                  _c("el-tab-pane", {
                    attrs: { label: "已禁用的店员", name: "0" },
                  }),
                  _c("el-tab-pane", {
                    attrs: { label: "已允许的店员", name: "1" },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "filter-container", attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 6 } },
                    [
                      _c("el-input", {
                        staticClass: "filter-item",
                        attrs: { placeholder: "商家名称" },
                        model: {
                          value: _vm.queryParams.shopName,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "shopName", $$v)
                          },
                          expression: "queryParams.shopName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 6 } },
                    [
                      _c("el-input", {
                        staticClass: "filter-item",
                        attrs: { placeholder: "员工手机号" },
                        model: {
                          value: _vm.queryParams.mobile,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "mobile", $$v)
                          },
                          expression: "queryParams.mobile",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12 } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: { type: "primary", icon: "el-icon-search" },
                          on: { click: _vm.handleFilter },
                        },
                        [_vm._v("查找")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: { type: "danger", icon: "el-icon-edit" },
                          on: { click: _vm.handleCreate },
                        },
                        [_vm._v("增加店员")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                { name: "sticky-header", rawName: "v-sticky-header" },
              ],
              attrs: {
                stripe: "",
                fit: "",
                "highlight-current-row": "",
                data: _vm.list,
                "header-cell-class-name": "table-header-cell",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  width: "60",
                  align: "center",
                  type: "index",
                  "class-name": "table-header-cell",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.$index +
                                1 +
                                (_vm.queryParams.page - 1) *
                                  _vm.queryParams.limit
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "员工名称",
                  prop: "userName",
                  "class-name": "name-col",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "昵称",
                  prop: "nickName",
                  "class-name": "name-col",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "手机号",
                  prop: "mobile",
                  "class-name": "name-col",
                },
              }),
              _c(
                "el-table-column",
                {
                  attrs: { label: "启用状态", width: "80", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("el-switch", {
                            staticClass: "rectangle md",
                            attrs: { "active-value": 1, "inactive-value": 0 },
                            on: {
                              change: function ($event) {
                                return _vm.handleUpdate(row)
                              },
                            },
                            model: {
                              value: row.status,
                              callback: function ($$v) {
                                _vm.$set(row, "status", $$v)
                              },
                              expression: "row.status",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                },
                [_vm._v('" ')]
              ),
              _c("el-table-column", {
                attrs: {
                  label: "是否后台管理员",
                  width: "120",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm._f("checkType")(row.isAdmin),
                              effect: "dark",
                              size: "medium",
                            },
                          },
                          [_vm._v(_vm._s(_vm._f("checkText")(row.isAdmin)))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm.queryParams.shopId
                ? [
                    _c("el-table-column", {
                      attrs: { label: "所属商家", prop: "shortName" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "是否店长",
                        width: "120",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: _vm._f("checkType")(row.isManager),
                                      effect: "dark",
                                      size: "medium",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm._f("checkText")(row.isManager))
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1311216696
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "是否有核销权限",
                        width: "120",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: _vm._f("checkType")(
                                        row.isAdmin ||
                                          row.isManager ||
                                          row.verifyStatus
                                      ),
                                      effect: "plain",
                                      size: "medium",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("checkText")(
                                          row.isAdmin ||
                                            row.isManager ||
                                            row.verifyStatus
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        947089950
                      ),
                    }),
                  ]
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  align: "center",
                  width: "120",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-dropdown",
                          { attrs: { trigger: "click" } },
                          [
                            _c("span", { staticClass: "el-dropdown-link" }, [
                              _vm._v(" 操作"),
                              _c("i", {
                                staticClass:
                                  "el-icon-arrow-down el-icon--right",
                              }),
                            ]),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleEdit(row)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-edit" }),
                                    _vm._v(" 编辑"),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: { divided: "" },
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleDelete(row)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-delete" }),
                                    _vm._v(" 删除"),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: { divided: "" },
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleReset(row)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-refresh" }),
                                    _vm._v(" 重置密码"),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
          _c("pagination", {
            attrs: {
              total: _vm.total,
              page: _vm.queryParams.page,
              limit: _vm.queryParams.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.queryParams, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.queryParams, "limit", $event)
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        2
      ),
      _vm.detailDialog
        ? _c("employee-detail", {
            attrs: {
              show: _vm.detailDialog,
              "employee-id": _vm.employeeId,
              "shop-info": _vm.storeInfo,
              stores: _vm.storeList,
            },
            on: {
              "update:show": function ($event) {
                _vm.detailDialog = $event
              },
              submit: _vm.handleSave,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }